var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [
        _vm._v("Accelerating onboarding times without burdening clients"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Due to the challenges around private company data collection, On-boarding processes are an inefficient and time-intensive bottleneck for Africa-focused banks. Asoko provides data and document collection services to enable banks with faster access to official data on new and existing corporate clients."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openSolutions },
          },
          [_vm._v("Read More")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }